// extracted by mini-css-extract-plugin
module.exports = {"mainpage":"_025a50318d--mainpage--R6E7C"};